import { observer } from 'mobx-react-lite'
import type { LegendEditorViewModel } from '@/features/legends/LegendEditor/LegendEditorViewModel'
import { SymbolPalette } from '@/features/legends/questions/components/SymbolPalette'

const testId = 'symbol-palette'

export interface SymbolPaletteContainerProps {
  vm: LegendEditorViewModel
}

/**
 * Jumps to any question of the legend; opened with ⌘K or Ctrl+K.
 */
export const SymbolPaletteContainer = observer(function SymbolPaletteContainer({
  vm,
}: SymbolPaletteContainerProps) {
  return (
    <SymbolPalette
      isOpen={vm.paletteModal.showing}
      items={vm.questionsVm.allQuestions.map((questionVm) => ({
        key: questionVm.cid,
        id: questionVm.id,
        text: questionVm.displayText,
        path: questionVm.ancestorPath,
        type: questionVm.type,
        friendlyType: questionVm.info.friendlyType,
        valueType: questionVm.valueType,
      }))}
      onSelect={vm.jumpToQuestion}
      onClose={vm.paletteModal.close}
      testId={testId}
    />
  )
})
